import React from "react";

/**
 * MangoLogo — brand mark, now the OpenPlay logo (component name kept so the
 * existing imports don't change).
 *
 * @param {number} size - Height in px (default 80)
 * @param {"icon"|"full"} variant - "icon" for the play mark, "full" for the full lockup
 * @param {"orange"|"white"} color - "orange" = full-color gradient, "white" = all white
 */
const MangoLogo = ({ size = 80, variant = "icon", color = "orange" }) => {
  const src =
    variant === "full"
      ? `/assets/logo/openplay-logo-${color === "white" ? "white" : "color"}.png`
      : `/assets/logo/openplay-icon-${color === "white" ? "white" : "color"}.png`;

  return (
    <img
      src={src}
      alt="OpenPlay"
      style={{ height: `${size}px`, width: "auto" }}
      className="mango-logo"
    />
  );
};

export default MangoLogo;
